export const AuthShell = ({ title, subtitle, children, testid }) => (
  <div className="min-h-screen flex items-center justify-center p-6 bg-[#fdf6ec]">
    <div
      data-testid={testid}
      className="w-full max-w-md bg-white border border-[#f0e4d4] rounded-3xl shadow-[0_12px_40px_rgba(232,131,107,0.12)] p-8"
    >
      <div className="flex flex-col items-center text-center mb-6">
        <img
          src="/icon-192.png"
          alt="AMOCANIAMOGATTI"
          className="w-16 h-16 rounded-2xl mb-3"
        />
        <h1 className="text-2xl font-extrabold text-[#2b2622]">{title}</h1>
        {subtitle && <p className="text-sm text-[#7a6f64] mt-1">{subtitle}</p>}
      </div>
      {children}
    </div>
  </div>
);
